import React from "react";
import { Box, Button, chakra, Flex, Text } from "@chakra-ui/react";

// Lime "add" card shown as the first item in the supplier grid — matches the
// "Add Data" call-to-action card in Data Collection (OrganizationPlanning),
// including the angled-arrow SVG motif in the bottom-right corner.
function AddSupplierCard({ onAdd }) {
  return (
    <Box
      w="100%"
      border="1px solid"
      borderColor="lime"
      borderRadius="lg"
      bg="lightLime"
      _hover={{ borderColor: "limeShade.400" }}
      transition="all 0.15s"
      overflow="hidden"
      position="relative"
      px={6}
      pt={5}
      pb={8}
    >
      <chakra.svg
        position="absolute"
        right="0"
        bottom="0"
        width="220px"
        height="180px"
        viewBox="0 0 175 114"
        preserveAspectRatio="xMaxYMax meet"
        fill="none"
        pointerEvents="none"
      >
        <path d="M31.2441 113.272C31.2066 113.31 31.1694 113.349 31.1318 113.387H0C4.3128 108.084 9.24419 102.6 14.8643 96.9404L86.3467 25.458L64.8271 25.4736L64.7959 2.35255H142.156L31.2441 113.272Z" fill="#85C22A" fillOpacity="0.15" />
        <path d="M174.876 18.7002L80.2031 113.387H47.501L158.521 2.36036H174.876V18.7002Z" fill="#85C22A" fillOpacity="0.15" />
        <path d="M174.884 112.425H174.999V113.387H174.87C174.873 113.069 174.876 112.751 174.876 112.433L151.763 112.362V90.6221L128.998 113.387H96.2949L174.884 34.7969V112.425Z" fill="#85C22A" fillOpacity="0.15" />
      </chakra.svg>
      <Text fontSize="22px" fontWeight="700" color="darkTeal" mb={3}>
        Add Supplier
      </Text>
      <Text fontSize="14px" color="gray.600" mb={5} maxW="70%" position="relative" zIndex={1}>
        Add a new supplier to track, manage and collect their emissions data.
      </Text>
      <Flex gap={2} position="relative" zIndex={1}>
        <Button
          bg="limeShade.600"
          color="white"
          borderRadius="full"
          _hover={{ bg: "limeShade.700" }}
          size="sm"
          onClick={onAdd}
        >
          Add supplier
        </Button>
      </Flex>
    </Box>
  );
}

export default AddSupplierCard;
